/**
 * 文字列が数値であることを確認してください
 * @param value
 */
export const isNumberString = function (value: string) {
  return /^-?[\d.]+(?:e-?\d+)?$/.test(value)
};
